import { Link } from "react-router-dom";
import { motion } from "framer-motion";

export default function CreativityLab() {
    return (
        <main className="bg-gradient-to-b from-slate-900 to-black text-gray-100 py-16 overflow-hidden">
            <section className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8 flex flex-col lg:flex-row items-center gap-12">

                {/* 🔹 Text Section */}
                <motion.div
                    className="flex-1 z-10"
                    initial={{ opacity: 0, y: 40 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 1, ease: 'easeOut' }}
                >
                    <h1 className="text-4xl sm:text-5xl font-bold text-white">
                        Creativity Lab
                    </h1>
                    <p className="mt-6 text-lg text-gray-300 leading-relaxed">
                        The SecureID <strong>Creativity Lab</strong> is our innovation hub —
                        a collaborative space where entrepreneurs, startups, and
                        organizations bring new ideas to life with our technical support,
                        development expertise, and secure infrastructure.
                    </p>

                    <h2 className="mt-10 text-2xl font-semibold text-white">
                        What We Offer
                    </h2>
                    <ul className="mt-4 list-disc pl-6 text-gray-300 space-y-2">
                        <li>
                            <strong>Technical Consulting</strong> — transform your idea into
                            a clear development roadmap with architecture guidance and
                            prototype design.
                        </li>
                        <li>
                            <strong>Software Development</strong> — from mobile apps to
                            backend APIs, our engineering team helps you build scalable
                            and secure products.
                        </li>
                        <li>
                            <strong>AI & Data Solutions</strong> — integrate ONNX-based
                            face or fingerprint recognition, analytics, and identity logic
                            into your applications.
                        </li>
                        <li>
                            <strong>Support & Maintenance</strong> — we assist you post-launch
                            with hosting, updates, and compliance management.
                        </li>
                    </ul>

                    <h2 className="mt-10 text-2xl font-semibold text-white">
                        Who It's For
                    </h2>
                    <p className="mt-3 text-gray-300 leading-relaxed">
                        Ideal for <strong>entrepreneurs</strong>, <strong>startups</strong>,
                        and <strong>agencies</strong> exploring new digital identity,
                        testing, or compliance-driven products. We bring your concepts to
                        market faster, securely, and affordably.
                    </p>

                    <p className="mt-10 text-center lg:text-left text-sm text-gray-400">
                        <Link to="/" className="text-indigo-400 hover:underline">
                            ← Back to Home
                        </Link>
                    </p>
                </motion.div>

                {/* 🔹 Animated Image */}
                <motion.div
                    className="flex-1 flex justify-center"
                    initial={{ opacity: 0, x: 200 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ duration: 1.2, ease: 'easeOut' }}
                >
                    <img
                        src="/Images/creativity-lab.jpg"
                        alt="Creativity Lab illustration"
                        className="w-[90%] max-w-md rounded-2xl shadow-2xl"
                    />
                </motion.div>
            </section>
        </main>
    );
}
